import api from '@services/api';
import { IResetDocument } from '@services/api/endpoints/edo';
import { Button, notification, Popconfirm } from 'antd';
import './index.scss';

interface Props {
  document_id: number;
  disabled?: boolean;
}

function EditLS({ document_id, disabled = false }: Props) {
  const onYes = async () => {
    let response: IResetDocument = await api.edo.resetDocument(document_id);
    if (response.success === true) {
      showNotification(response.message);
      refreshPage();
    } else {
      showNotification(response.message);
    }
  };

  const refreshPage = () => {
    if (localStorage.getItem('showSide') === 'false') {
      window.location.replace(`${window.location.href}?showSide=false`);
    } else {
      window.location.reload();
    }
  };

  const showNotification = (message: string) => {
    notification.info({
      message: 'Уведомление',
      description: message,
    });
  };

  const button = (
    <Button type="primary" className="edit-ls" disabled={disabled}>
      Очистить ЛС
    </Button>
  );

  if (disabled) {
    return button;
  }

  return (
    <Popconfirm
      title="Вы хотите очистить ЛС?"
      okText="Да"
      cancelText="Нет"
      onConfirm={onYes}
    >
      {button}
    </Popconfirm>
  );
}

export default EditLS;
